import { FC, InputHTMLAttributes, memo } from 'react';
import classNames from 'classnames';

import style from 'assets/scss/ui/switch.module.scss';

type PropTypes = {
  checked: boolean;
  className?: string;
  id: string;
  isError?: boolean;
  onChange: (checked: boolean) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'id' | 'type'>;

const Switch: FC<PropTypes> = ({
  id,
  name,
  isError,
  onChange,
  className,
  ...props
}) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event?.target?.checked);
    }
  };

  return (
    <div className={classNames(style.switch, className)}>
      <input
        {...props}
        id={id}
        name={name}
        type="checkbox"
        onChange={handleCheckboxChange}
        className={style.switch__input}
      />

      <label htmlFor={id} className={style.switch__label}>
        <span className={style.switch__label__inner} />
        <span className={style.switch__label__switch} />
      </label>
    </div>
  );
};

export default memo(Switch);
